import defaultCode from "./defaultCode";
import lesson from "./lesson";

export default {
    name: "Breadth-First Search",
    defaultCode,
    lesson,
    difficulty: 1,
};
